<div class="mb-4 w-full box-bg rounded-lg p-5 md:py-10 md:px-10">
  <div class="w-full flex flex-col mb-6">
    <h2>{{ 'Login' | translate }}</h2>
    <h6 class="font-light">{{ 'to OffconOn personal account' | translate }}</h6>
  </div>
  <form class="grip max-w-full" [formGroup]="form" (submit)="login()">
    <div class="mb-6">
      <input
        id="email"
        formControlName="email"
        type="text"
        pInputText
        class="w-full p-3 mb-2"
        placeholder="{{ 'Email' | translate }}" />
      <offconon-shared-ui-form-errors [ctrl]="form.get('email')" />
      <small class="text-gray"
        >{{ 'Need new verification email?' | translate }}
        <a class="text-primary" [routerLink]="['/resend-email']">{{ 'Resend' | translate }}</a>
      </small>
    </div>
    <div class="mb-6">
      <p-password
        #password
        id="password"
        styleClass="p-password p-component p-inputwrapper p-input-icon-right w-full rounded-lg  mb-2"
        formControlName="password"
        placeholder="{{ 'Password' | translate }}"
        [feedback]="false"
        [toggleMask]="true"
        [inputStyle]="{ width: '100%' }" />

      <small class="text-gray">
        {{ 'If you have forgotten your password, you can reset it.' | translate }}
        <a class="text-primary" [routerLink]="['/auth/reset-password']">{{
          'Click here' | translate
        }}</a>
      </small>
    </div>
    @if (recaptchaService.captchaError()) {
      <div class="mb-4">
        <small class="text-red-500">{{ recaptchaService.captchaError() }}</small>
      </div>
    }

    <div class="flex justify-between items-center flex-wrap">
      <p-button
        size="small"
        styleClass="!p-0"
        label="{{ 'Create your account' | translate }}"
        [link]="true"
        (click)="buttonClicked('/auth/registration')" />
      <p-button
        id="login-submit-button"
        icon="pi pi-arrow-right ml-3"
        iconPos="right"
        type="submit"
        [disabled]="form.invalid"
        label="{{ 'Login' | translate }}"
        [loading]="loading"
        [rounded]="true" />
    </div>
  </form>
</div>
<offconon-social-login />
